export const METRIC_NAMES = [
  // Discounted bookings
  "DISCOUNTED_BOOKINGS_SOLD",
  // Average discount
  "AVERAGE_DISCOUNT_PER_BOOKING",
  "AVERAGE_DISCOUNT_PERCENTAGE_PER_BOOKING",
  // Search coverage
  "SEARCH_COVERAGE_PERCENTAGE",
] as const;

export const METRIC_STALE_TIME = 60 * 60 * 1000; // 1 hour
